export * from './user.service';
<template>
    <div id="app" :class="'themed-' + themaKleur">

        <main v-if="browser.name !== 'chrome' && browser.name !== 'edge-chromium'">
            <div style="text-align: center; padding: 50px 20px 0;">Deze applicatie is gemaakt voor Google Chrome en Microsoft Edge</div>
            <div class="content loading"></div>
        </main>

        <header id="header" v-if="browser.name == 'chrome' || browser.name == 'edge-chromium'">
            <bread-crumb></bread-crumb>
            <div class="heading">
                <h2 class="h2">{{pageTitle}}</h2>
            </div>

            <div class="nav flex">
                <div class="appNav flex">
                    <figure class="brand">
                        <router-link :to="{ name: 'themaoverzicht'}">
                            <svg class="icon icon-taaloceaan-logo"><use xlink:href="#icon-taaloceaan-logo"></use></svg>
                        </router-link>
                    </figure>

                    <ul>
                        <li>
                            <button type="button" @click="toggleFullScreen()">
                                <svg class="icon icon-fullscreen"><use xlink:href="#icon-fullscreen"></use></svg>
                            </button>
                        </li>
                        <li>
                            <router-link :to="{ name: 'login'}">
                                <svg class="icon icon-log-out"><use xlink:href="#icon-log-out"></use></svg>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <figure class="bg">
                <svg preserveAspectRatio='none' xmlns="http://www.w3.org/2000/svg" width="1280" height="81" viewBox="0 0 1280 81">
                    <path fill="#F9AC00" fill-rule="evenodd" d="M1280,2.50210085 C1251.04768,8.62656116 1206.80257,10.7107875 1149.73967,10.5851418 C1070.97058,10.4104637 1049.39824,0.756085706 968.60461,0.0328569675 C887.060626,-0.696500828 878.299639,10.9601755 795.893327,10.8184411 C706.628296,10.6644485 693.872288,1.24126902 603.092392,1.1478009 C529.541024,1.07118768 525.295027,8.13087366 437.050632,9.16055526 C360.348551,10.0553976 350.796024,1.04798205 277.671958,3.14258731 C207.994627,5.13836153 188.694151,11.8760986 129.296534,12.3472698 C72.7188548,12.7954571 30.2869933,7.15558745 0,0.87943298 L0,80.1474374 L1280,80.1474374 L1280,2.50210085 Z" transform="matrix(1 0 0 -1 0 80.147)" />
                </svg>
            </figure>
        </header>
        <transition name="page-transition" v-if="browser.name == 'chrome' || browser.name == 'edge-chromium'">
            <router-view :key="$route.fullPath"></router-view>
        </transition>
    </div>
</template>

<script>
    import BreadCrumb from "./components/BreadCrumb";
    const { detect } = require('detect-browser');

    export default {
        components: {
            BreadCrumb
        },
        data() {
            return {
                themaKleur: "yellow",
                pageTitle: "Themaoverzicht",
                fullscreen: false,
                browser: detect()
            }
        },
        mounted() {
            this.$root.$on("set-thema-kleur", (themaId) => {
                this.setThemaKleur(themaId);
            });
            this.$root.$on("set-page-title", (title) => {
                this.setPageTitle(title);
            });
        },
        methods: {
            setThemaKleur(themaId) {
                this.themaKleur = this.$root.themas.find(t => t.id == themaId).kleur;
            },
            setPageTitle(title) {
                this.pageTitle = title;
            },
            toggleFullScreen() {
                if (!this.fullScreen) {
                    document.getElementById("app").requestFullscreen();
                    this.fullScreen = true;
                }
                else {
                    document.exitFullscreen();
                    this.fullScreen = false;
                }
            }
        }, computed: {
            alert() {
                return this.$store.state.alert
            }
        },
        watch: {
            $route() {
                // clear alert on location change
                this.$store.dispatch('alert/clear');
            }
        }
    }
</script>